import { forwardRef } from "react"

import { Button } from "antd"
import cls from "classname"
import PropTypes from "prop-types"

import "./styles.less"

export const ButtonComponent = forwardRef(({ className, text, onClick, ...props }, ref) => {
  return (
    <Button ref={ref} onClick={onClick} className={cls(className, "btn")} {...props}>
      {text}
      {props.children}
    </Button>
  )
})

ButtonComponent.propTypes = {
  className: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func
}

export default ButtonComponent
